(function () {
  "use strict";
  if (window.__glNewsletterAccountInstalled) return;
  window.__glNewsletterAccountInstalled = true;

  var SDK_URL = "https://cdn.shopify.com/shopifycloud/shop-js/modules/v2/loader.sdk.esm.js";
  var API_ORIGIN = "https://assist-api.goldylost.com";
  var SHOP_SCOPE = "shop_app:oauth phone:verified";
  var states = new Set();
  var initialized = new WeakSet();
  var sdkPromise = null;

  function loadSdk() {
    if (window.ShopSDK && typeof window.ShopSDK.initialize === "function") return Promise.resolve(window.ShopSDK);
    if (sdkPromise) return sdkPromise;
    sdkPromise = new Promise(function (resolve, reject) {
      var script = Array.from(document.scripts).find(function (candidate) { return candidate.src === SDK_URL; });
      var owned = !script;
      if (!script) { script = document.createElement("script"); script.type = "module"; script.src = SDK_URL; }
      var timer = window.setTimeout(function () { finish(false); }, 12000);
      function finish(loaded) {
        window.clearTimeout(timer);
        script.removeEventListener("load", onLoad);
        script.removeEventListener("error", onError);
        if (loaded && window.ShopSDK && typeof window.ShopSDK.initialize === "function") resolve(window.ShopSDK);
        else { if (owned) script.remove(); reject(new Error("Shop is unavailable.")); }
      }
      function onLoad() { finish(true); }
      function onError() { finish(false); }
      script.addEventListener("load", onLoad);
      script.addEventListener("error", onError);
      if (owned) document.head.appendChild(script);
    }).catch(function (error) { sdkPromise = null; throw error; });
    return sdkPromise;
  }

  function post(path, body, signal, keepalive) {
    return fetch(API_ORIGIN + "/v1/newsletter/shop/" + path, {
      method: "POST", credentials: "omit", cache: "no-store", redirect: "error",
      headers: { "content-type": "application/json" }, body: JSON.stringify(body),
      signal: signal, keepalive: !!keepalive
    });
  }

  function mount(form) {
    if (initialized.has(form)) return;
    initialized.add(form);
    var name = form.querySelector('[name="contact[first_name]"]');
    var email = form.querySelector('[name="contact[email]"]');
    var summary = form.querySelector("[data-gl-newsletter-profile]");
    var summaryEmail = form.querySelector("[data-gl-newsletter-email]");
    var edit = form.querySelector("[data-gl-newsletter-edit]");
    var shopMount = form.querySelector("[data-gl-newsletter-shop]");
    var status = form.querySelector("[data-gl-newsletter-status]");
    var manualFields = form.querySelector("[data-gl-newsletter-manual-fields]");
    var manualAction = form.querySelector("[data-gl-newsletter-manual-action]");
    var accountAction = form.querySelector("[data-gl-newsletter-account-action]");
    var phone = form.querySelector("[data-gl-newsletter-phone]");
    if (!name || !email || !summary || !summaryEmail || !edit || !shopMount || !status || !manualFields || !manualAction || !accountAction) return;
    var step = form.closest(".gl-nl__step");
    var card = form.closest(".gl-nl__card");
    var customer = form.dataset.customerLoggedIn === "true";
    var phase = customer ? "prefilled" : "idle";
    var revision = 0;
    var attempt = null;
    var feature = null;
    var recognition = null;
    var explicit = false;
    var controller = null;
    var requestTimer = null;
    var readyTimer = null;
    var expiryTimer = null;
    var ownedName = customer ? name.value : null;
    var ownedEmail = customer ? email.value : null;
    setPhone(customer && phone ? phone.value : "");
    var observer = null;
    var disposed = false;

    function activeStep() { return !step || step.classList.contains("active"); }
    function visible(allowBackground) {
      if (disposed || !form.isConnected || (!allowBackground && document.hidden) || !activeStep() || !form.getClientRects().length) return false;
      var rect = form.getBoundingClientRect();
      return rect.bottom > 0 && rect.top < window.innerHeight && rect.right > 0 && rect.left < window.innerWidth;
    }
    function untouched() { return name.value === "" && email.value === ""; }
    function nativeResult() { return !!form.querySelector("[data-gl-nl-native-success], [data-gl-nl-native-error]"); }
    function eligible(allowBackground) { return !customer && !nativeResult() && visible(allowBackground) && untouched(); }
    function current(version) { return revision === version && !disposed && form.isConnected; }
    function say(text) { status.textContent = text; status.hidden = !text; }
    function contactComplete() {
      return name.value.trim().length >= 2 && name.validity.valid && email.validity.valid &&
        (name.maxLength <= 0 || name.value.length <= name.maxLength) &&
        (email.maxLength <= 0 || email.value.length <= email.maxLength);
    }
    function setPhone(value) {
      if (!phone) return;
      phone.value = typeof value === "string" && /^\+[1-9]\d{6,14}$/.test(value) ? value : "";
      phone.disabled = !phone.value;
    }
    function hide(element, hidden) { if (element.hidden !== hidden) element.hidden = hidden; }
    function displayMode(mode, partialProfile) {
      form.dataset.glNewsletterAccountMode = mode;
      if (card) card.dataset.glNewsletterAccountMode = mode;
      var manual = mode === "guest";
      if (manual) setPhone("");
      hide(manualFields, !manual);
      hide(manualAction, !manual);
      hide(summary, manual && !partialProfile);
      hide(summaryEmail, mode === "recognized");
      hide(accountAction, mode !== "account");
    }
    function stopRequest() {
      if (requestTimer) window.clearTimeout(requestTimer);
      requestTimer = null;
      if (controller) controller.abort();
      controller = null;
    }
    function requestSignal(ms) {
      stopRequest();
      controller = new AbortController();
      requestTimer = window.setTimeout(function () { if (controller) controller.abort(); }, ms);
      return controller.signal;
    }
    function stopFeature() {
      if (readyTimer) window.clearTimeout(readyTimer);
      readyTimer = null;
      if (feature) { try { feature.destroy(); } catch (_) {} }
      feature = null;
      shopMount.replaceChildren();
      shopMount.hidden = true;
      recognition = null;
      explicit = false;
    }
    function cancelAttempt(keepalive) {
      var old = attempt;
      attempt = null;
      if (old) post("cancel", old, undefined, keepalive).catch(function () {});
    }
    function clearOwned() {
      if (ownedName !== null && name.value === ownedName) name.value = "";
      if (ownedEmail !== null && email.value === ownedEmail) email.value = "";
      ownedName = ownedEmail = null;
    }
    function retire(options) {
      options = options || {};
      revision += 1;
      phase = "retired";
      stopRequest();
      stopFeature();
      cancelAttempt(options.keepalive);
      if (expiryTimer) window.clearTimeout(expiryTimer);
      expiryTimer = null;
      if (!options.preserveMode) {
        displayMode("guest");
        setPhone("");
      }
      if (options.clear) clearOwned();
      else ownedName = ownedEmail = null;
      email.readOnly = false;
      say(options.message || "");
    }
    function showSummary() {
      summaryEmail.textContent = email.value;
      displayMode(contactComplete() ? "account" : "guest", true);
      say("");
    }
    function reveal() {
      var recognized = phase === "ready" && feature && recognition === true && eligible();
      var hidden = !recognized;
      if (shopMount.hidden !== hidden) shopMount.hidden = hidden;
      if (recognized) displayMode("recognized");
    }
    function profile(value) {
      if (!value || typeof value !== "object" || value.emailVerified !== true || typeof value.email !== "string" ||
          value.email.length > 320 || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value.email) ||
          (value.name !== null && typeof value.name !== "string") || typeof value.expiresAt !== "string") return null;
      var expires = Date.parse(value.expiresAt);
      if (!Number.isFinite(expires) || expires <= Date.now() || expires > Date.now() + 15 * 60000) return null;
      if (email.maxLength > 0 && value.email.length > email.maxLength) return null;
      return {
        email: value.email, name: typeof value.name === "string" ? value.name.trim().slice(0, name.maxLength > 0 ? name.maxLength : 120) : "", expires: expires,
        phone: value.phoneVerified === true && typeof value.phone === "string" && /^\+[1-9]\d{6,14}$/.test(value.phone) ? value.phone : ""
      };
    }
    async function complete(event) {
      if (phase !== "ready" || !explicit || !eligible(true) || !attempt) return;
      if (!event || event.signedIn !== true || typeof event.shopConsentToken !== "string" || !event.shopConsentToken || event.shopConsentToken.length > 8192) {
        retire({ message: "You can enter your name and email below." });
        return;
      }
      var version = revision;
      var bound = attempt;
      phase = "verifying";
      shopMount.hidden = true;
      say("Verifying your Shop details…");
      try {
        var response = await post("verify", { attemptToken: bound.attemptToken, revision: bound.revision, consentToken: event.shopConsentToken }, requestSignal(15000));
        if (!response.ok) throw new Error("Shop verification failed.");
        var result = await response.json();
        var verified = profile(result.profile);
        if (!verified) throw new Error("Invalid verified profile.");
        if (!current(version) || phase !== "verifying" || !eligible(true)) return;
        attempt = null;
        stopRequest();
        if (expiryTimer) window.clearTimeout(expiryTimer);
        expiryTimer = null;
        stopFeature();
        phase = "prefilled";
        name.value = verified.name;
        email.value = verified.email;
        setPhone(verified.phone);
        ownedName = name.value;
        ownedEmail = email.value;
        showSummary();
        expiryTimer = window.setTimeout(function () {
          if (phase === "prefilled") retire({ clear: true, message: "Your Shop details expired. Please enter your name and email below." });
        }, verified.expires - Date.now());
        if (!name.value.trim()) name.focus();
      } catch (_) {
        if (current(version)) retire({ message: "Shop sign-in is unavailable. You can enter your name and email below." });
      }
    }
    async function begin() {
      if (phase !== "idle" || !eligible()) return;
      if (form.dataset.shopApiUrl !== API_ORIGIN || !/^[a-z0-9][a-z0-9-]*\.myshopify\.com$/.test(form.dataset.shopDomain || "")) { phase = "retired"; return; }
      phase = "loading";
      var version = revision;
      try {
        var response = await post("start", { shopDomain: form.dataset.shopDomain }, requestSignal(6000));
        if (!response.ok) throw new Error("Shop is unavailable.");
        var result = await response.json();
        if (!current(version) || phase !== "loading" || !eligible()) {
          if (result && typeof result.attemptToken === "string" && typeof result.revision === "string") post("cancel", { attemptToken: result.attemptToken, revision: result.revision }).catch(function () {});
          return;
        }
        stopRequest();
        if (!result.shopLogin) { phase = "retired"; return; }
        if (typeof result.shopLogin.clientId !== "string" || !result.shopLogin.clientId ||
            typeof result.attemptToken !== "string" || !/^[A-Za-z0-9_-]{43}$/.test(result.attemptToken) ||
            typeof result.revision !== "string" || !/^[0-9a-f-]{36}$/i.test(result.revision) || result.expiresIn !== 600) throw new Error("Invalid Shop attempt.");
        attempt = { attemptToken: result.attemptToken, revision: result.revision };
        expiryTimer = window.setTimeout(function () { if (attempt) retire(); }, result.expiresIn * 1000);
        var sdk = await loadSdk();
        if (!current(version) || phase !== "loading" || !eligible()) { cancelAttempt(); return; }
        readyTimer = window.setTimeout(function () { if (current(version) && phase === "loading") retire(); }, 12000);
        var created = await sdk.initialize({ apiKey: result.shopLogin.clientId, locale: "en", scope: SHOP_SCOPE }).create("login", {
          attributes: { buttonType: "continue", buttonLayout: "standalone", scope: SHOP_SCOPE },
          appearance: { preferredLoginExperience: "popup", variables: { "--buttons-radius": "12px", "--shop-pay-button-width": "180px", "--shop-pay-button-height": "36px", "--font-paragraph--size": "14px" } },
          onLoad: function (event) {
            if (!current(version) || (phase !== "loading" && phase !== "ready") || !event || typeof event.userFound !== "boolean") return;
            recognition = event.userFound;
            if (!recognition && feature) retire();
            else reveal();
          },
          onBeforeAuthenticate: function () {
            if (current(version) && phase === "ready" && recognition === true && eligible()) {
              explicit = true;
              say("Complete the Shop sign-in window, or choose Use another email.");
            }
          },
          onComplete: complete,
          onError: function () { if (current(version) && (phase === "loading" || phase === "ready")) retire({ message: "You can enter your name and email below." }); },
          onRestart: function () { if (current(version) && explicit) retire({ message: "You can enter your name and email below." }); }
        });
        if (!current(version) || phase !== "loading" || !eligible()) { created.destroy(); return; }
        if (readyTimer) window.clearTimeout(readyTimer);
        readyTimer = null;
        feature = created;
        phase = "ready";
        shopMount.appendChild(created.element);
        if (recognition === false) retire();
        else reveal();
      } catch (_) { if (current(version)) retire(); }
    }
    function changed() {
      if (phase !== "submitted") retire();
    }
    function check() {
      if (disposed) return;
      if (!form.isConnected) { dispose(); return; }
      if (nativeResult() && phase !== "retired" && phase !== "submitted") { retire(); return; }
      if (phase === "idle") { if (!untouched()) retire(); else void begin(); }
      else if ((phase === "loading" || phase === "ready" || phase === "verifying") && !eligible(explicit || phase === "verifying")) retire();
      else if (phase === "prefilled" && ((ownedName !== null && name.value !== ownedName) || (ownedEmail !== null && email.value !== ownedEmail))) retire();
      else reveal();
    }
    function submitted() {
      retire({ preserveMode: true });
      phase = "submitted";
    }
    function pagehide() {
      if (phase === "submitted") return;
      if (customer) { stopFeature(); return; }
      retire({ clear: true, keepalive: true });
    }
    function dispose() {
      if (disposed) return;
      retire({ keepalive: true });
      disposed = true;
      if (observer) observer.disconnect();
      if (intersection) intersection.disconnect();
      name.removeEventListener("input", changed);
      name.removeEventListener("change", changed);
      email.removeEventListener("input", changed);
      email.removeEventListener("change", changed);
      form.removeEventListener("submit", submitted);
      edit.removeEventListener("click", editProfile);
      states.delete(state);
    }
    function editProfile() {
      retire({ clear: true });
      email.focus();
    }
    name.addEventListener("input", changed);
    name.addEventListener("change", changed);
    email.addEventListener("input", changed);
    email.addEventListener("change", changed);
    form.addEventListener("submit", submitted);
    edit.addEventListener("click", editProfile);
    shopMount.hidden = true;
    if (customer && email.value && summaryEmail.textContent.trim() === email.value) showSummary();
    else { displayMode("guest"); if (customer) { phase = "retired"; ownedName = ownedEmail = null; } }
    var state = { check: check, pagehide: pagehide };
    states.add(state);
    var intersection = typeof IntersectionObserver === "function" ? new IntersectionObserver(function () { check(); }, { threshold: 0.01 }) : null;
    if (intersection) intersection.observe(form);
    observer = new MutationObserver(check);
    observer.observe(step || form, { attributes: true, subtree: true, attributeFilter: ["class", "hidden", "style"] });
    check();
  }

  function scan() {
    document.querySelectorAll("form[data-gl-newsletter-account]").forEach(mount);
    states.forEach(function (state) { state.check(); });
  }
  function start() {
    scan();
    var mutations = new MutationObserver(function (records) {
      var removed = false;
      records.forEach(function (record) {
        if (record.removedNodes.length) removed = true;
        record.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.matches("form[data-gl-newsletter-account]")) mount(node);
          node.querySelectorAll("form[data-gl-newsletter-account]").forEach(mount);
        });
      });
      if (removed) states.forEach(function (state) { state.check(); });
    });
    mutations.observe(document.documentElement, { childList: true, subtree: true });
    window.addEventListener("scroll", function () { states.forEach(function (state) { state.check(); }); }, { passive: true });
    window.addEventListener("resize", function () { states.forEach(function (state) { state.check(); }); }, { passive: true });
    document.addEventListener("visibilitychange", function () { states.forEach(function (state) { state.check(); }); });
    window.addEventListener("pagehide", function () { states.forEach(function (state) { state.pagehide(); }); });
    window.addEventListener("pageshow", scan);
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start, { once: true });
  else start();
})();
